import Vue from 'vue';
import DialogVue from './dialog.vue';

let protocolConstructor = Vue.extend(DialogVue); // 构造函数
let instance; // 实例对象

export const Dialog = (options = {}) => {
  if (typeof options === 'string') {
    options = {
      message: options,
    };
  }
  instance = new protocolConstructor({
    data: options,
  });
  instance.id = `dialog`;
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  // instance.vm.visible = true;
  // instance.dom = instance.vm.$el;
  return instance.vm;
};
